<h1 [translateParams]="{
            time: formatDate(context.data.log.time)
        }"
    translate
    matDialogTitle>
    audit_data_modal_title
</h1>

<mat-dialog-content
    class="audit-data-modal"
    data-cy="audit-data-modal">
    <div class="row">
        <div class="layout-row">
            <ul class="no-bullets">
                <li>
                    <span class="key">
                        {{ 'audit_data_modal_component' | translate }}:
                    </span>
                    {{ ('AuditComponent_' + context.data.log.component) | translate }}
                </li>
                <li>
                    <span class="key">
                        {{ 'audit_data_modal_action' | translate }}:
                    </span>
                    {{ ('AuditAction_' + context.data.log.action) | translate }}
                </li>
                <li>
                    <span class="key">
                        {{ 'audit_data_modal_operation' | translate }}:
                    </span>{{ context.data.log.operation }}
                </li>
            </ul>
        </div>
        <ng-container *ngFor="let change of context.data.changes">
            <div *ngIf="!isEmptyObject(change.current)"
                 class="layout-row layout-wrap">
                <div class="audit-change-title flex-gt-xs-100">
                    {{ change.title }}
                </div>
                <div *ngIf="change.isUpdate"
                     class="flex-gt-xs-50 flex-xs-100">
                    <ul class="no-bullets">
                        <ng-container *ngFor="let key of change.keys">
                            <li *ngIf="!key.startsWith('__')">
                                <ui-json-formatter [matTooltip]="change.previous['__' + key]"
                                                   [data]="applyFormatting(change.previous[key])"
                                                   [levelsOpen]="2"
                                                   [key]="key | capitalize"
                                                   [objectPlaceholder]="'global_json_object_placeholder' | translate"
                                                   [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
                                    <ng-template let-info>
                                        <span [class.text-diff-old]="change.current &&
                                                                    isArray(change.previous[key]) ?
                                                                    difference(change.previous[key], change.current[key]).includes(info?.value) :
                                                                    change.differenceMap[key]">
                                            {{ info?.value }}
                                        </span>
                                    </ng-template>
                                </ui-json-formatter>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div [class.flex-gt-xs-50]="change.isUpdate"
                     [class.flex-gt-xs-100]="!change.isUpdate"
                     class="flex-xs-100">
                    <ul class="no-bullets">
                        <ng-container *ngFor="let key of change.keys">
                            <li *ngIf="!key.startsWith('__')">
                                <ui-json-formatter [matTooltip]="change.current['__' + key]"
                                                   [data]="applyFormatting(change.current[key])"
                                                   [levelsOpen]="2"
                                                   [key]="key | capitalize"
                                                   [objectPlaceholder]="'global_json_object_placeholder' | translate"
                                                   [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
                                    <ng-template let-info>
                                        <span [class.text-diff-new]="change.previous &&
                                                                     isArray(change.current[key]) ?
                                                                     difference(change.current[key], change.previous[key]).includes(info?.value) :
                                                                     change.differenceMap[key]">
                                            {{ info?.value }}
                                        </span>
                                    </ng-template>
                                </ui-json-formatter>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </ng-container>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button"
            data-cy="close-modal-button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
